import ABCyaPhaser from "@abcya/abcya_phaser";

export default class AudioNumber
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} number 
     */
    constructor(scene, number)
    {
        this.scene = scene;

        this.firstAudioNumber = number;
        this.secondAudioNumber = 0;

        if (number > 20)
        {
            let remaining = number % 10;

            this.firstAudioNumber = number - remaining;
            this.secondAudioNumber = remaining;
        }
    }

    play()
    {
        this.firstSound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        if (this.secondAudioNumber != 0)
        {
            this.firstSound.once(Phaser.Sound.Events.COMPLETE, this.playSecondSound, this);
        }
        else
        {
            this.firstSound.once(Phaser.Sound.Events.COMPLETE, () => this.firstSound.destroy());
        }

        ABCyaPhaser.Audio.playSound("" + this.firstAudioNumber, this.firstSound);
    }

    playSecondSound()
    {
        ABCyaPhaser.Audio.playSound("" + this.secondAudioNumber, this.firstSound);
        this.firstSound.once(Phaser.Sound.Events.COMPLETE, () => this.firstSound.destroy());
    }
}